import { smoothScroll } from "./scrollHelpers";
import type { AllFilterType } from "../../../../../../CommonComponents/custom_filter/types";

interface ListLike {
  scrollTo?: (offset: number) => void;
  state?: { scrollOffset?: number };
  _outerRef?: HTMLElement | null;
}

export interface HandleUnreadBadgeClickParams {
  listRef: React.RefObject<any>;
  loadLatestEntries: (filters: AllFilterType, isFilterApplied: boolean, fromWs: boolean) => Promise<void>;
  allFilters: AllFilterType;
  setDataCount: React.Dispatch<React.SetStateAction<number>>;
  setIsFrozen?: (frozen: boolean) => void;
}

/**
 * Handles user clicking the "X new messages" badge or the scroll-to-top button.
 * Smoothly scrolls the list back to top (0), fetches the latest entries,
 * clears the unread data count, and unfreezes live streaming.
 */
export function handleUnreadBadgeClick({
  listRef,
  loadLatestEntries,
  allFilters,
  setDataCount,
  setIsFrozen,
}: HandleUnreadBadgeClickParams): void {
  // Load latest entries from backend / WS cache
  loadLatestEntries(allFilters, false, false);

  // Smooth scroll to top offset 0
  const list = listRef?.current;
  if (list) {
    const currentOffset = list.state?.scrollOffset ?? list._outerRef?.scrollTop ?? 0;
    if (typeof list.scrollTo === "function") {
      smoothScroll(list, 0, 250, currentOffset);
    } else if (list._outerRef) {
      list._outerRef.scrollTop = 0;
    }
  }

  // Clear unread count & unfreeze
  setDataCount(0);
  if (setIsFrozen) {
    setIsFrozen(false);
  }
}
